var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-in-wallet-button"},[_c('BaseButton',{attrs:{"text":"Open in wallet","href":_vm.deepLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }